module.exports = __webpack_public_path__ + "img/agmichImago.648f55ca.png";